<template>
  <div class="row">
    <div class="col-md-12">
      <h4 class="title">Records Manage</h4>
    </div>
    <div class="col-md-12 card">
      <div class="card-body row">
        <div class="col-sm-1">
          <p-button class="no-margin" type="default" block outline round  @click="openAddModal()"> <i class="fa fa-plus"></i> </p-button>
        </div>
        <div class="col-sm-5"  v-if="pagination">
          <el-select
            class="select-default"
            v-model="pagination.per_page"
            placeholder="Per page"
            @change="changePerPage()"
          >
            <el-option
              class="select-default"
              v-for="item in perPageOptions"
              :key="item"
              :label="item"
              :value="item"
            ></el-option>
          </el-select>
        </div>
        <div class="col-sm-6">
          <div class="pull-right">
            <fg-input
              class="input-sm"
              placeholder="Search"
              v-model="searchQuery"
              addon-right-icon="nc-icon nc-zoom-split"
            ></fg-input>
          </div>
        </div>
        <div class="col-sm-12 mt-2">
          <el-table
            class="table-striped"
            :data="tableData"
            border
            style="width: 100%;"
            height="600"
          >
            <el-table-column type="expand" fixed>
              <template slot-scope="props">
                <!-- <p v-for="(item, index) in props.row.items" :key="index">{{ item }}</p> -->
                <img :src="props.row.imageURL" alt="" v-if="(props.row.imageURL.split('.').pop()) != 'pdf'"/>
                <!-- <iframe :src="props.row.imageURL" width="550px" height="600px"  v-if="(props.row.imageURL.split('.').pop()) == 'pdf'"></iframe> -->
                <pdf :src="props.row.imageURL" v-if="(props.row.imageURL.split('.').pop()) == 'pdf'"></pdf>
              </template>
            </el-table-column>
            <el-table-column
              v-for="(column) in tableColumns"
              :key="column.label"
              :min-width="column.minWidth"
              :prop="column.prop"
              :label="column.label"
              :sortable="column.sortable || false"
              :align="column.align"
              :header-align="column.align"
              v-if="!column.hidden"
              :fixed="column.fixed || false"
              :formatter="column.formatter || null"
            ></el-table-column>
            
            <el-table-column :min-width="200" fixed="right" class-name="td-actions" label="Actions" align="center">

              <template slot-scope="props">
                <p-button type="info" size="sm" icon @click="handleView(props.$index, props.row)">
                  <i class="fa fa-eye"></i>
                </p-button>
                <p-button
                  type="success"
                  size="sm"
                  icon
                  @click="handleEdit(props.$index, props.row)"
                >
                  <i class="fa fa-edit"></i>
                </p-button>
                <p-button
                  v-if="!props.row.isCritical"
                  type="danger"
                  size="sm"
                  icon
                  @click="handleDelete(props.$index, props.row)"
                >
                  <i class="fa fa-trash"></i>
                </p-button>
                <p-button
                  v-if="!props.row.isCritical"
                  type="default"
                  size="sm"
                  icon
                  @click="handleDownload(props.$index, props.row)"
                >
                  <i class="fa fa-download"></i>
                </p-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="col-sm-6 pagination-info"  v-if="pagination">
          <p
            class="category"
          >Showing {{ pagination.from }} to {{ pagination.to }} of {{ pagination.total }} entries</p>
        </div>
        <div class="col-sm-6"  v-if="pagination">
          <p-pagination
            class="pull-right"
            v-model="pagination.current_page"
            :per-page="Number.parseInt(pagination.per_page)"
            :total="pagination.total"
            @input="changePage()"
          ></p-pagination>
        </div>
      </div>
    </div>

    <modal
      :show.sync="modals.add"
      headerClasses="justify-content-center"
      footer-classes="justify-content-center"
      >
      <h5 slot="header" class="modal-title">Records Manage</h5>
      <form>
        <div class="row">

          <div class="form-group col-12">
            <label for>Title</label>
            <fg-input
              name="title"
              v-model="model.title"
              v-validate="modelValidations.title"
              placeholder="Record Title"
              :error="getError('title')"
            >
            </fg-input>
          </div>

          <div class="form-group col-12">
            <label for>Description</label>
            <fg-input
              name="desc"
              v-model="model.desc"
              v-validate="modelValidations.desc"
              placeholder="Record Description"
              :error="getError('desc')"
            >
            </fg-input>
          </div>

          <div class="form-group col-6">
            <label for>Type</label>
            <fg-input
              name="record_type_id"
              v-model="model.record_type_id"
              v-validate="modelValidations.record_type_id"
              :error="getError('record_type_id')"
            >
              <el-select
                name="record_type_id"
                :class="!getError('record_type_id') ? 'select-default' : 'select-danger'"
                class="select-default"
                placeholder="Select Record Type"
                v-model="model.record_type_id"
                filterable
              >
                <el-option
                  v-for="(option, index) in recordTypes"
                  class="select-success"
                  :value="option.id"
                  :label="`${option.name}`"
                  :key="index"
                ></el-option>
              </el-select>
            </fg-input>
          </div>

          <div class="form-group col-6">
            <label for>Patient</label>
            <fg-input
              name="patient_id"
              v-model="model.patient_id"
              v-validate="modelValidations.patient_id"
              :error="getError('patient_id')"
            >
              <el-select
                name="patient_id"
                :class="!getError('patient_id') ? 'select-default' : 'select-danger'"
                class="select-default"
                placeholder="Select Patient"
                v-model="model.patient_id"
                filterable
              >
                <el-option
                  v-for="(option, index) in patients"
                  class="select-success"
                  :value="option.id"
                  :label="`${option.patient_id} - ${option.name} -  ${option.phone}`"
                  :key="index"
                ></el-option>
              </el-select>
            </fg-input>
          </div>

          <div class="form-group col-12">
            <label for>Date</label>
            <fg-input
              name="datetime"
              v-model="model.datetime"
              v-validate="modelValidations.datetime"
              :error="getError('datetime')"
            >
              <el-date-picker v-model="model.date" type="date" placeholder="Pick a day" :picker-options="datePickerOptions"></el-date-picker>
            </fg-input>
          </div>

          <div class="col-12">
            <div class="picture-container">
                <el-upload
                  drag
                  ref="imageUpload"
                  class="picture"
                  :action="image_upload_url"
                  :on-change="handlePreview"
                  :auto-upload="true"
                  :show-file-list="true"
                  list-type="picture"
                  name="image"
                  :data="{location: 'reports'}"
                  :headers="image_upload_headers"
                  :on-success="handleSuccess"
                  :on-remove="handleRemove"
                >
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">Drop file here or <em>click to upload</em></div>
                <div class="el-upload__tip" slot="tip">jpg/png/pdf files with a size less than 1Mb</div>
                <!-- <img v-if="model.imageURL" :src="model.imageURL" class="picture-src"> -->
              </el-upload>
            </div>
          </div>

        </div>
      </form>
      <template slot="footer">
        <p-button type="success" @click="validate()" v-if="model.image">Save Record</p-button>
      </template>
    </modal>

  </div>
</template>


<script>
import axios from "axios";
import Vue from "vue";
import { Modal } from "src/components/UIComponents";
import { Progress, Upload, Table, TableColumn, Select, Option, Slider, DatePicker } from "element-ui";
import PPagination from "src/components/UIComponents/Pagination.vue";
// import users from "../Tables/users.js";
import swal from 'sweetalert2'
import pdf from 'vue-pdf'

import { mapGetters } from "vuex";

Vue.use(Table);
Vue.use(TableColumn);
Vue.use(Select);
Vue.use(Option);
Vue.use(Slider);

export default {
  components: {
    [DatePicker.name]: DatePicker,
    PPagination,
    Modal,
    [Upload.name]: Upload,
    [Progress.name]: Progress,
    pdf
  },
  mounted() {
    this.$store.dispatch("fetchRecords", { per_page: 10, page: 1 });
    this.$store.dispatch("fetchSimplePatientsAll");
    this.$store.dispatch("fetchRecordTypesAll");
  },
  watch: {
      searchQuery: function (val) {
          this.$store.dispatch("fetchRecords", {
              searchQuery: this.searchQuery,
              per_page: this.pagination.per_page,
              page: this.pagination.current_page
          }); 
      }
  },
  computed: {
    ...mapGetters({
      tableData: "getRecords",
      pagination: "getPagination",
      patients: "getPatients",
      recordTypes: "getRecordTypes"
    }),
    image_upload_url(){
      return `${process.env.VUE_APP_API_URL}/auth/image`
    },
    image_upload_headers(){
      let authToken = JSON.parse(localStorage.getItem('zyro_user_token')).access_token;
      return { 'Authorization': `Bearer ${authToken}` };
    },
    /***
     * Searches through table data and returns a paginated array.
     * Note that this should not be used for table with a lot of data as it might be slow!
     * Do the search and the pagination on the server and display the data retrieved from server instead.
     * @returns {computed.pagedData}
     */
    queriedData() {
      // if (!this.searchQuery) {
      //   if(this.locations)
      //   this.pagination.total = this.locations.length;
      //   else
      //   this.pagination.total = 0
      //   return this.pagedData;
      // }
      // let result = this.locations.filter(row => {
      //   let isIncluded = false;
      //   for (let key of this.propsToSearch) {
      //     let rowValue = row[key].toString();
      //     if (rowValue.includes && rowValue.includes(this.searchQuery)) {
      //       isIncluded = true;
      //     }
      //   }
      //   return isIncluded;
      // });
      // this.pagination.total = result.length;
      // return result.slice(this.from, this.to);
    }
  },
  data() {
    return {
      scope: 'add',
      modals: {
        add: false,
        edit: false
      },
      datePickerOptions: {
        shortcuts: [{
          text: 'Today',
          onClick (picker) {
            picker.$emit('pick', new Date())
          }
        },
        {
          text: 'Tomorrow',
          onClick (picker) {
            const date = new Date()
            date.setTime(date.getTime() + 3600 * 1000 * 24 * 1)
            picker.$emit('pick', date)
          }
        },
        {
          text: 'Next week',
          onClick (picker) {
            const date = new Date()
            date.setTime(date.getTime() + 3600 * 1000 * 24 * 7)
            picker.$emit('pick', date)
          }
        }]
      },
      perPageOptions: ["10", "30", "50", "100", "250", "500"],
      searchQuery: "",
      propsToSearch: [
        "title", "desc", "date"
      ],
      tableColumns: [
        {
          prop: "id",
          label: "ID",
          minWidth: 80,
          hidden: true,
          align: "center"
        },
        {
          prop: "patient.patient_id",
          label: "PAT ID",
          minWidth: 200,
          fixed: true,
          sortable: true,
          align: "center"
        },
        {
          prop: "patient.name",
          label: "PAT Name",
          minWidth: 250,
          fixed: true,
          sortable: true,
          align: "left"
        },
        {
          prop: "title",
          label: "Title",
          minWidth: 200,
          fixed: false,
          sortable: true,
          align: "left"
        },
        {
          prop: "desc",
          label: "Description",
          minWidth: 250,
          fixed: false,
          sortable: true,
          align: "left"
        },
        {
          prop: "date",
          label: "Date",
          minWidth: 200,
          fixed: false,
          sortable: true,
          align: "center",
          formatter: function(row, column, cellValue, index){
            var d = new Date(row.date);
            var options = { year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric' }
            return  d.toLocaleDateString('en-US', options); 
          }
        }
      ],
      model: {
        id: null,
        title: null,
        desc: null,
        record_type_id: null,
        patient_id: null,
        imageURL: "/static/img/upload.png",
        image: null,
        date: null
      },
      modelValidations: {
        title: {
          required: true
        },
        desc: {
          required: false
        },
        record_type_id: {
          required: true
        },
        patient_id: {
          required: true
        },
        image: {
          required: true
        },
        date: {
          required: true
        },
      }
    };
  },
  methods: {
    handlePreview(file) {
      if(file.status == "success")
        this.model.imageURL = file.response.data.url;
      else
        this.model.imageURL = URL.createObjectURL(file.raw);
    },
    handleSuccess(response, file, fileList) {
      this.model.image = response.data.path;
    },
    handleRemove(file, fileList){
      console.log(file)
      this.$store.dispatch("deleteImage", {path: file.response.data.path})
      this.model.imageURL = "/static/img/upload.png";
      this.model.image = null;
    },
    changePerPage() {
      this.$store.dispatch("fetchRecords", {
        per_page: this.pagination.per_page,
        page: 1, searchQuery : this.searchQuery
      });
    },
    changePage() {
      this.$store.dispatch("fetchRecords", {
        per_page: this.pagination.per_page,
        page: this.pagination.current_page, searchQuery : this.searchQuery
      });
    },
    handleEdit(index, row) {
      this.model.id = row.id;
      this.model.record_type_id = row.record_type.id;
      this.model.patient_id = row.patient.id;
      this.model.imageURL = row.imageURL;
      this.model.image = row.image;
      this.model.title = row.title;
      this.model.desc = row.desc;
      this.model.date = row.date;
      this.scope = 'edit';
      this.$refs.imageUpload.fileList = [];
      this.modals.add = true;
    },
    handleDelete(index, row) {
      swal({
          title: "Are you sure?",
          text: `You won't be able to revert this!`,
          showCancelButton: true,
          confirmButtonClass: "btn btn-danger btn-fill",
          cancelButtonClass: "btn btn-default btn-fill",
          confirmButtonText: "Delete it!",
          buttonsStyling: false
      })
      .then(result => { this.$store.dispatch("deleteRecord", row.id); })
      .catch(cancel => { console.log(cancel) });

      // this.$store.dispatch("deleteRecord", row.id);
    },
    getError(fieldName) {
      return this.errors.first(fieldName);
    },
    validate() {
      this.$validator.validateAll().then(isValid => {
        if (isValid) {
          this.modals.add = false;
          switch(this.scope){
            case 'add'  : this.$store.dispatch("createRecord", this.model); break;
            case 'edit' : this.$store.dispatch("updateRecord", this.model); break;
          }
        }
      });
    },
    openAddModal(){
      this.model.id = null;
      this.model.record_type_id = null;
      this.model.patient_id = null;
      this.model.imageURL = "/static/img/upload.png";
      this.model.image = null;
      this.model.title = null;
      this.model.desc = null;
      this.model.date = null;
      this.scope = 'add';
      this.$refs.imageUpload.fileList = [];
      this.modals.add = true;
    },
    handleDownload(index, row) {
        axios({
          url: row.imageURL,
          method: 'get',
          responseType: "blob" // important
        }).then(response => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          let ext = row.imageURL.split('.').pop();
          link.setAttribute("download", `${row.title}.${ext}`);
          document.body.appendChild(link);
          link.click();
        });
      // window.open(`${row.imageURL}`, "_blank", );
    },
    handleView(index, row) {
      window.open(`${row.imageURL}`, "_blank", );
    }

  }
};
</script>

<style lang="scss">
.el-table .td-actions {
  button.btn {
    margin-right: 5px;
  }
}

button.no-margin{
  margin: 0;
}

.el-table,
.el-table tr,
.el-table thead th {
  background-color: white !important;
}

.form-group .el-input-number {
  width: 35%;
  outline: none;
}
.el-input--small .el-input__inner {
  border-radius: 50px;
}

.picture-container{
  text-align: center;
}
</style>
